// dependancies
import React from "reactn";

import ProgressBar from "../../../_common/progressBar/ProgressBar";
import ProgressItem from "../../../_common/progressItem/ProgressItem";
const UserProgress = () => {

    return (
        <>
            <ProgressBar>

                <ProgressItem
                    firstTitle="Enter your details"
                    nextTitle="Your new details"
                    hideLast={true}
                    centerText={true}
                    active={true}
                ></ProgressItem>

                <ProgressItem
                    nextTitle="Review"
                ></ProgressItem>
            </ProgressBar>
        </>
    );
};

export default UserProgress;
